module.exports = __webpack_public_path__ + "img/icon_coordinates5.b05fb1b8.png";